<template>
  <form @submit.prevent="handleSubmit">
    <div class="card">
      <div
        class="card-header"
        v-if="expandable"
        style="cursor: pointer;"
        @click="expanded = !expanded"
      >
        <div class="card-header-title">
          {{ $t("support_ticket.compose_reply") }}
        </div>
      </div>

      <div class="card-content" v-if="expanded">
        <b-field
          :label="$t('support_ticket.title')"
          v-if="withTitle"
          :type="{ 'is-danger': form.errors.any('title') }"
          :message="form.errors.get('title')"
        >
          <b-input
            ref="titleInput"
            v-model="form.title"
            :placeholder="$t('support_ticket.title')"
            autofocus
            @input="form.errors.clear('title')"
          ></b-input>
        </b-field>

        <b-field
          :label="
            withTitle ? $t('support_ticket.desc') : $t('support_ticket.reply')
          "
          :type="{ 'is-danger': form.errors.any('body') }"
          :message="form.errors.get('body')"
        >
          <b-input
            ref="bodyInput"
            type="textarea"
            v-model="form.body"
            :placeholder="
              withTitle ? $t('support_ticket.desc') : $t('support_ticket.reply')
            "
            @input="form.errors.clear('body')"
          ></b-input>
        </b-field>

        <b-field :label="$t('support_ticket.file')">
          <input class="input" ref="attachments" type="file" multiple />
        </b-field>
      </div>
    </div>

    <div class="card">
      <div class="card-content" v-if="expanded">
        <button
          type="submit"
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
          :disabled="disabled"
        >
          {{ $t("support_ticket.send" + (withTitle ? "" : "_reply")) }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    url: String,
    disabled: Boolean,
    expandable: Boolean,
    withTitle: Boolean
  },

  data() {
    return {
      form: new window.Form({
        title: "",
        body: ""
      }),

      attachments: [],

      expanded: !this.expandable
    };
  },

  watch: {
    expanded(expanded) {
      if (expanded) {
        this.$nextTick(() => {
          var firstElement = this.withTitle
            ? this.$refs.titleInput
            : this.$refs.bodyInput;

          firstElement.focus();
        });
      }
    }
  },

  methods: {
    handleSubmit() {
      if (this.form.processing) {
        return false;
      }

      this.form
        .attach(this.$refs.attachments.files)
        .post(this.url)
        .takeAtLeast(500)
        .then(({ data }) => {
          this.$buefy.toast.open(this.$t("support_ticket.sent"));

          if (this.expandable) {
            this.expanded = false;
          }

          this.$emit("added", data);

          this.form.title = "";
          this.form.body = "";
        });
    }
  }
};
</script>
